// The athlete is created even when the invitation email fails, so the toast must say which.
export const getCreateAthleteFeedback = data => {
    // No email was supplied, so no invitation was attempted
    if (data?.syntheticEmail === true) {
        return {
            type: 'success',
            message:
                'Athlete created without an email. Add their email later to send an account-setup invitation.'
        };
    }
    if (data?.emailSent === true) {
        return { type: 'success', message: 'Athlete created and invitation email sent' };
    }
    return {
        type: 'warning',
        message:
            data?.warning ||
            'Athlete created, but the invitation email could not be sent. Check the email address.'
    };
};
